// This util returns progress of level in range between 0 and 1
export const calculateLevelProgress = (
    currentPoints: number,
    levelPoints: number,
    nextLevelPoints: number,
): number => {
    if (levelPoints === nextLevelPoints) {
        return 1;
    }

    const progress = (currentPoints - levelPoints) / (nextLevelPoints - levelPoints);

    if (Number.isNaN(progress)) {
        return 0;
    }

    return Math.max(progress, 0);
};
